// default to 16km diameter ~5mi radius
export default 16000;
